$( document ).ready(function() {
  $('svg g#ch a').each(function() {
    var region = $(this).children(":first").attr('id');
    if(region) {
      region_name = $('.map-region.'+region).val();
      if(region_name) {
        var d = document.createElement('span');
        d.classList.add('map-tooltip');
        d.innerText = region_name;
        var t = tippy("#"+region, {
          arrow: true,
          allowHTML: true,
          //interactive: true,
          //interactiveBorder: 20,
          //placement: 'auto',
          followCursor: true,
          html: d,
        });
      }
    }
  });
});
